module.exports = __webpack_public_path__ + "static/Chloe_Sharrock-ee114a4d277a2ed3975c0ea78c0f8698.webp";